import { Controller } from '@hotwired/stimulus';
import NwAvatar from '../libs/nw_avatar';

export default class extends Controller {
  static targets = ['input', 'output'];

  connect() {
    const avatarImageData = this.outputTarget.getAttribute('data-image');

    if (avatarImageData) {
      this.outputTarget.innerHTML = NwAvatar.createAvatarSVG(avatarImageData);
    } else {
      const randomAvatar = NwAvatar.createRandomAvatar();
      this.outputTarget.innerHTML = NwAvatar.createAvatarSVG(randomAvatar.toString());
    }
  }

  randomize() {
    const randomAvatar = NwAvatar.createRandomAvatar();
    this.outputTarget.innerHTML = NwAvatar.createAvatarSVG(randomAvatar.toString());
    this.inputTarget.value = randomAvatar.toString();
  }

  declare inputTarget: HTMLInputElement;

  declare outputTarget: HTMLElement;
}
